import template from './mapLocationEditPage.html';
import controller from './mapLocationEditPage.controller';
import './mapLocationEditPage.scss';

let mapLocationEditPageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default mapLocationEditPageComponent;
